import { render, staticRenderFns } from "./RelationshipMortgage.vue?vue&type=template&id=2e97b9af"
import script from "./RelationshipMortgage.vue?vue&type=script&lang=js"
export * from "./RelationshipMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports